import { render, staticRenderFns } from "./g-selector.vue?vue&type=template&id=4f49390f&scoped=true"
import script from "./g-selector.vue?vue&type=script&lang=js"
export * from "./g-selector.vue?vue&type=script&lang=js"
import style0 from "./g-selector.vue?vue&type=style&index=0&id=4f49390f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f49390f",
  null
  
)

export default component.exports